/* Corporate Gifting page behaviour: lead form submit, tier pre-fill, sticky bar, GA4 events. */
(function () {
  if (window.__cgPageInit) return;
  window.__cgPageInit = true;

  function track(name, params) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params); } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params)); }
    } catch (e) {}
  }

  var forms = Array.prototype.slice.call(document.querySelectorAll('[data-cg-form]'));

  /* Impressions (one per placement per page view) */
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var p = en.target.dataset.placement;
        if (en.isIntersecting && !seen[p]) { seen[p] = true; track('lead_form_impression', { form_placement: p, form_name: 'corporate_gifting' }); }
      });
    }, { threshold: 0.5 });
    forms.forEach(function (f) { io.observe(f); });
  }

  /* Tier links: remember the tier and show it on every form */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cg-tier]');
    if (!a) return;
    var tier = a.getAttribute('data-cg-tier');
    forms.forEach(function (f) {
      var input = f.querySelector('input[name="tier_interest"]');
      if (input) input.value = tier;
      var note = f.querySelector('[data-cg-tier-note]');
      if (note) { note.hidden = false; note.querySelector('span').textContent = tier; }
    });
    track('lead_tier_click', { tier: tier, form_name: 'corporate_gifting' });
  });

  /* Submit */
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = form.querySelector('[data-cg-error]');
      err.hidden = true;
      form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });

      var data = new FormData(form);
      if (data.get('company_website')) return; // honeypot

      var bad = [];
      var email = (data.get('email') || '').trim();
      var phone = (data.get('phone') || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) bad.push('email');
      if (phone && phone.replace(/\D/g, '').length < 10) bad.push('phone'); // optional, but complete if given
      if (bad.length) {
        bad.forEach(function (n) { form.querySelector('[name="' + n + '"]').setAttribute('aria-invalid', 'true'); });
        err.textContent = form.dataset.msgInvalid;
        err.hidden = false;
        form.querySelector('[name="' + bad[0] + '"]').focus();
        return;
      }

      var endpoint = form.dataset.endpoint;
      var attr = window.fwsAttribution ? window.fwsAttribution() : {};
      var payload = {
        form: 'corporate_gifting',
        placement: form.dataset.placement,
        store: form.dataset.store,
        email: email,
        phone: phone,
        name: (data.get('name') || '').trim(),
        company: (data.get('company') || '').trim(),
        recipients: (data.get('recipients') || '').trim(),
        budget: data.get('budget') || '',
        tier_interest: data.get('tier_interest') || '',
        page_url: location.href,
        first_touch: attr.first_touch || null,
        last_touch: attr.last_touch || null,
        submitted_at: new Date().toISOString()
      };

      if (!endpoint) {
        console.warn('[cg] No form endpoint set in the theme editor.');
        err.textContent = form.dataset.msgError;
        err.hidden = false;
        return;
      }

      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          var lt = payload.last_touch || {};
          track('lead_form_submit', {
            form_name: 'corporate_gifting',
            form_placement: payload.placement,
            lead_id: res.lead_id || '',
            budget: payload.budget,
            tier: payload.tier_interest,
            source: lt.utm_source || '',
            medium: lt.utm_medium || '',
            campaign: lt.utm_campaign || ''
          });
          var tpl = form.parentNode.querySelector('template[data-cg-thanks]');
          var thanks = document.createElement('div');
          thanks.className = 'cg-form cg-thanks';
          thanks.setAttribute('tabindex', '-1');
          thanks.setAttribute('role', 'status');
          thanks.appendChild(tpl.content.cloneNode(true));
          form.replaceWith(thanks);
          thanks.focus();
        })
        .catch(function () {
          btn.disabled = false;
          err.textContent = form.dataset.msgError;
          err.hidden = false;
        });
    });
  });

  /* Sticky bar: show once the hero form has scrolled away, hide while any form is on screen */
  var bar = document.querySelector('[data-cg-sticky]');
  if (bar && 'IntersectionObserver' in window) {
    var hero = document.querySelector('[data-cg-hero]');
    var visible = new Map();
    var passedHero = false;
    var update = function () {
      var anyForm = Array.from(visible.values()).some(Boolean);
      var show = passedHero && !anyForm;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    };
    if (hero) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible.set(en.target, en.isIntersecting);
          passedHero = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        update();
      }).observe(hero);
    } else {
      passedHero = true;
    }
    var formWatcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible.set(en.target, en.isIntersecting); });
      update();
    });
    document.querySelectorAll('[data-cg-form-section]').forEach(function (s) { formWatcher.observe(s); });
    update();
  }
})();
